import { render } from "./ViewSourceFile.vue?vue&type=template&id=2a18f68d&scoped=true"
import script from "./ViewSourceFile.vue?vue&type=script&lang=js"
export * from "./ViewSourceFile.vue?vue&type=script&lang=js"

import "./ViewSourceFile.vue?vue&type=style&index=0&id=2a18f68d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a18f68d"]])

export default __exports__